class InfiniteSlider {
  position = 0;
  speed = 2;
  totalWidth = 0;
  slides = [];
  spacing = 0;
  constructor() {
    this.init();
  }

  init = () => {
    const inner = document.querySelector(".js-infinite-slider-inner");
    if (!inner) {
      return;
    }
    this.slides = inner.querySelectorAll(".js-infinite-slider-slide");
    if (!this.slides.length) {
      return;
    }
    this.spacing = parseInt(getComputedStyle(this.slides[0]).marginLeft);
    this.slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      inner.appendChild(clone);
    });
    this.slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      inner.appendChild(clone);
    });
    this.slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      inner.appendChild(clone);
    });
    this.totalWidth = Array.from(this.slides).reduce(
      (sum, s) => sum + s.offsetWidth + this.spacing,
      0
    );

    this.animateSlide(inner);

    window.addEventListener("resize", () => {
      this.spacing = parseInt(getComputedStyle(this.slides[0]).marginLeft);
      this.totalWidth = Array.from(this.slides).reduce(
        (sum, s) => sum + s.offsetWidth + this.spacing,
        0
      );
    });
  };

  animateSlide = (inner) => {
    this.position -= this.speed;
    if (this.position * -1 >= this.totalWidth) {
      this.position = 0;
    }
    inner.style.transform = `translateX(${this.position}px)`;
    setTimeout(() => {
      requestAnimationFrame(() => this.animateSlide(inner));
    }, 10);
  };
}

new InfiniteSlider();
